import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";

export interface Country {
  code: string;
  name: string;
  prefix: string;
  flag: string;
}

// Get country flag emoji
const getCountryFlag = (countryCode: string): string => {
  const codePoints = countryCode
    .toUpperCase()
    .split("")
    .map((char) => 127397 + char.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
};

// Get country name from country code
const getCountryName = (countryCode: string): string => {
  try {
    const displayNames = new Intl.DisplayNames(["en"], { type: "region" });
    return displayNames.of(countryCode) || countryCode;
  } catch {
    return countryCode;
  }
};

// Generate countries list using react-phone-number-input utilities
export const COUNTRIES: Country[] = getCountries().map((countryCode) => ({
  code: countryCode,
  name: getCountryName(countryCode),
  prefix: `+${getCountryCallingCode(countryCode)}`,
  flag: getCountryFlag(countryCode),
}));
